import { Box, Grid, LinearProgress, Typography } from "@mui/material";
import { MetricType } from "@commercial-publishing/shared-types/social";
import { getMetricDisplayName } from "@/utils/social.ts";

interface ProgressSectionProps {
  performance: number;
  target: number;
  metric: MetricType;
}

const ProgressSection = ({
  performance,
  target,
  metric,
}: ProgressSectionProps) => {
  const value =
    target > 0 ? Math.round((performance / target) * 10000) / 100 : 0;

  return (
    <Grid container spacing={0}>
      <Grid item xs={12}>
        <Typography variant="body2" color="text.secondary">
          {getMetricDisplayName(metric)}:
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box sx={{ width: "100%", mr: 1 }}>
            <LinearProgress
              variant="determinate"
              value={Math.min(100, value)}
            />
          </Box>
          <Box sx={{ minWidth: 35 }}>
            <Typography
              variant="body2"
              color="text.secondary"
            >{`${value}%`}</Typography>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body2" color="text.secondary">
          {performance.toLocaleString()} / {target.toLocaleString()}
        </Typography>
      </Grid>
    </Grid>
  );
};
export default ProgressSection;
